import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export type AddpPricingBillingFrequency = 'monthly' | 'quarterly' | 'annual';

export interface AddpPricingParams {
  companyId: number;
  popId: number;
  xcoId: string;
  currency: string;
  serviceKey?: string | null;
  productIds: number[];
}

export interface AddpPricingQuote {
  amount: number;
  currency: string;
  billingFrequency: AddpPricingBillingFrequency;
}

export interface AddpPricingPayload {
  amount: number | null;
  currency: string;
  billingFrequency: AddpPricingBillingFrequency;
}

@Injectable({
  providedIn: 'root'
})
export class AddpPricingService {
  quoteAddp(params: AddpPricingParams): Observable<AddpPricingQuote> {
    // Temporary stub: replace with real pricing API call when available.
    return of({
      amount: 1080,
      currency: 'USD',
      billingFrequency: 'monthly'
    });
  }
}
